// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swagger {\n  height: 90vh;\n  overflow: auto;\n}\n.swagger::-webkit-scrollbar {\n  display: none;\n}", "",{"version":3,"sources":["webpack://./src/components/swagger/Swagger.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,cAAA;AACJ;AAAI;EACI,aAAA;AAER","sourcesContent":[".swagger{\n    height: 90vh;\n    overflow: auto;\n    &::-webkit-scrollbar{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
